import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-behind-square-2, copy 2, layers, pages"} maskId="square-filled-radius-0-stroke-1-IconSquareBehindSquare2"><path fillRule="evenodd" clipRule="evenodd" d="M22 2H8V8H2V22H16V16H22V2ZM16 15H21V3H9V8H16V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareBehindSquare2;
